export const PAGE_LIST_BLOCK_FETCH = 'pageListBlock/PAGE_LIST_BLOCK_FETCH';
export const PAGE_LIST_BLOCK_FETCHED = 'pageListBlock/PAGE_LIST_BLOCK_FETCHED';
export const PAGE_LIST_BLOCK_ERROR = 'pageListBlock/PAGE_LIST_BLOCK_ERROR';
export const PAGE_LIST_BLOCK_SELECTED_PAGE_CHANGE =
  'pageListBlock/PAGE_LIST_BLOCK_SELECTED_PAGE_CHANGE';
export const PAGE_LIST_BLOCK_SELECTED_PAGE_CHANGED =
  'pageListBlock/PAGE_LIST_BLOCK_SELECTED_PAGE_CHANGED';
export const LIST_BLOCK_LAST_SEARCHED_CATEGORY =
  'pageListBlock/PAGE_LIST_BLOCK_LAST_SEARCHED_CATEGORY';
